import React from 'react';

interface AxisLogoProps {
  variant?: 'color' | 'white' | 'black';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const AxisLogo: React.FC<AxisLogoProps> = ({ 
  variant = 'color', 
  size = 'medium',
  className = ''
}) => {
  const getSize = () => {
    switch (size) {
      case 'small': return { width: 160, height: 40 };
      case 'large': return { width: 240, height: 60 };
      default: return { width: 200, height: 50 };
    }
  };

  const { width, height } = getSize();

  // Use the actual logo image based on variant
  const getLogoImage = () => {
    switch (variant) {
      case 'white':
        return require('./Logo - Axis White@4x.png');
      case 'black':
        return require('./Axis Logo Black.png');
      default: // color
        return require('./Axis Logo Color Transparent.png');
    }
  };

  return (
    <div className={`axis-logo ${className}`} style={{ display: 'flex', alignItems: 'center' }}>
      <img 
        src={getLogoImage()} 
        alt="Axis Integrated Mental Health" 
        style={{ 
          width: width, 
          height: height, 
          objectFit: 'contain',
          maxWidth: '100%'
        }}
      />
    </div>
  );
};

export default AxisLogo;
